import { RegionShared } from "@1games-ru/region-shared";
import { useLayoutEffect } from "react";
import rpc from "@1games-ru/rage-rpc";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { setDesignIsPresentation, setSelectedPreviewDesignVariant } from "@/domains/estate/slice";

export default function useShowDesignPresentation() {
  const dispatch = useAppDispatch();
  useLayoutEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Interior.InteriorPreviewShow,
      async (state: typeof RegionShared.Cef.Requests.InteriorPreviewShowRequest): Promise<void> => {
        dispatch(setDesignIsPresentation(true));
        dispatch(setSelectedPreviewDesignVariant(state));
      },
    );

    rpc.register(RegionShared.Cef.Events.Interior.InteriorPreviewHide, async (): Promise<void> => {
      dispatch(setDesignIsPresentation(false));
      dispatch(setSelectedPreviewDesignVariant(null));
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Interior.InteriorPreviewShow);
      rpc.unregister(RegionShared.Cef.Events.Interior.InteriorPreviewHide);
    };
  }, [dispatch]);
}
